var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from 'react';
import PropTypes from 'prop-types';
import styles from './styles.scss';

var Link = function Link(_ref) {
  var children = _ref.children,
      icon = _ref.icon,
      rest = _objectWithoutProperties(_ref, ['children', 'icon']);

  return React.createElement(
    'a',
    _extends({ className: styles.link }, rest),
    icon && React.createElement(
      'div',
      { className: styles.linkIcon },
      icon
    ),
    children
  );
};

Link.propTypes = {
  children: PropTypes.node,
  icon: PropTypes.node
};

export default Link;
//# sourceMappingURL=Link.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/es/src/SideMenu/core/footer/Link.js